import React from 'react';
import { motion } from 'framer-motion';
interface TestimonialCardProps {
  quote: string;
  author: string;
  role?: string;
  delay?: number;
}
export function TestimonialCard({
  quote,
  author,
  role,
  delay = 0
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay
  }} className="bg-white rounded-lg p-8 shadow-lg" data-id="element-124">
      <div className="text-6xl text-[var(--color-primary)] mb-4" data-id="element-125">"</div>
      <p className="text-base text-[var(--color-text-light)] mb-6 italic leading-relaxed" data-id="element-126">
        {quote}
      </p>
      <div className="border-t border-gray-200 pt-4" data-id="element-127">
        <div className="font-semibold text-[var(--color-text)]" data-id="element-128">{author}</div>
        {role && <div className="text-sm text-[var(--color-text-light)]" data-id="element-129">{role}</div>}
      </div>
    </motion.div>;
}